export default {
  welcome: require('./welcome/welcome-image.svg'),
  back: require('./back-arrow/back-arrow.svg'),
  check: require('./ok-check-mark/ok-check-mark.svg'),
  checkbox: require('./check.svg'),
  creditcard: require('./credit-card/credit-card.svg'),
  bank: require('./newcreditcard/bankpayment.svg'),
  differentpayment: require('./different/different.svg'),
  paypal: require('./different/different.svg'),
  close: require('./close-btn/x.svg'),
  bitmap: require('./bitmap/bitmap.svg'),
  info: require('./infoPrivate/info.svg'),
  failUpdate: require('./failedUpdate/icons-error-copy-2.svg'),
  smallArrowOkUpdate: require('./small-arrow-ok-update/icons-ok.svg'),
  smallArrowNoUpdate: require('./small-arrow-no-update/icons-x.svg'),
  shape: require('./shape/shape.svg'),
  insight: require('./insight/insight.svg'),
  newcreditcard: require('./newcreditcard/new-credit-card.svg'),
  bigInsight: require('./insight/Bigger_insight_icon.svg'),
  warning: require('./warning/warning.svg'),
  paymentSMS: require('./insight/paymentSMS.svg'),
  successPayment: require('./ok-check-mark/success-payment.svg'),
  backArrow: require('./back-arrow/Back-black.svg')
};
